import axios from "axios";

const DRIVER_URI_PREFIX = "/v1/driver";
export const DRIVER_URIS = {
  GET_LIST_DRIVER: `${DRIVER_URI_PREFIX}/list`,
  GET_LIST_HISTORY_ALL_DRIVER: `${DRIVER_URI_PREFIX}/history`,
  GET_LIST_HISTORY_DRIVER: (driverId) =>
    `${DRIVER_URI_PREFIX}/${driverId}/history`,
  EXPORT_LIST_DRIVER: `${DRIVER_URI_PREFIX}/export`,
  EXPORT_ASSIGN_DRIVER: `${DRIVER_URI_PREFIX}/exportDriverByDriverId`,
  ADD_DRIVER: `${DRIVER_URI_PREFIX}/add`,
  EDIT_DRIVER: `${DRIVER_URI_PREFIX}/edit`,
  GET_DRIVER_BY_ID: (id) => `${DRIVER_URI_PREFIX}/${id}/detail`,
  SET_STATUS: `${DRIVER_URI_PREFIX}/set-status`,
  IMPORT_DRIVER_IMAGE: `${DRIVER_URI_PREFIX}/import-driver-image`,
  GET_IMPORT_PROGRESS: (importId) =>
    `${DRIVER_URI_PREFIX}/import-progress?importId=${importId}`,
  CANCEL_IMPORT_IMAGE: (importId) =>
    `${DRIVER_URI_PREFIX}/cancel-import-driver-image?importId=${importId}`,
  GET_LIST_IMPORT_CONFIRM: `${DRIVER_URI_PREFIX}/list-confirm`,
  IMPORT_CONTINUE: `${DRIVER_URI_PREFIX}/import-continue`,
  UNLOCK_DRIVER: (driverId) =>
  `${DRIVER_URI_PREFIX}/${driverId}/unlock`,
};

export default {
  getListDriver(params, signal) {
    return axios.get(DRIVER_URIS.GET_LIST_DRIVER, { params, signal });
  },
  getHistoryAllDriver(params) {
    return axios.get(DRIVER_URIS.GET_LIST_HISTORY_ALL_DRIVER, { params });
  },
  getHistoryOfDriver(params) {
    const { driverId, ...rest } = params;
    return axios.get(DRIVER_URIS.GET_LIST_HISTORY_DRIVER(driverId), {
      params: rest,
    });
  },
  exportListDriver(params) {
    const searchParams = new URLSearchParams(params);
    const link = `${DRIVER_URIS.EXPORT_LIST_DRIVER}?${searchParams.toString()}`;
    window.open(link);
  },
  exportAssignDriver(params) {
    const link = `${DRIVER_URIS.EXPORT_ASSIGN_DRIVER
      }?listDriverId=${params.toString()}`;
    window.open(link);
  },
  addDriver(data) {
    return axios.post(DRIVER_URIS.ADD_DRIVER, data);
  },
  editDriver(data) {
    return axios.post(DRIVER_URIS.EDIT_DRIVER, data);
  },
  getDriverById(id) {
    return axios.get(DRIVER_URIS.GET_DRIVER_BY_ID(id));
  },
  requestSetStatusDriver(data) {
    return axios.post(DRIVER_URIS.SET_STATUS, data);
  },
  importDriver(data, signal, config) {
    return axios.post(DRIVER_URIS.IMPORT_DRIVER_IMAGE, data, {
      ...config,
      signal,
    });
  },
  getImportProgress(importId) {
    return axios.get(DRIVER_URIS.GET_IMPORT_PROGRESS(importId));
  },
  cancelImportImage(importId) {
    return axios.post(DRIVER_URIS.CANCEL_IMPORT_IMAGE(importId));
  },
  getListConfirmImportDriver(params) {
    return axios.get(DRIVER_URIS.GET_LIST_IMPORT_CONFIRM, { params });
  },
  importContinueDriver(data) {
    return axios.post(DRIVER_URIS.IMPORT_CONTINUE, data);
  },
  unlockDriver(driverId) {
    return axios.put(DRIVER_URIS.UNLOCK_DRIVER(driverId))
  }
};



// WEBPACK FOOTER //
// ./src/services/driver-service.js